import React from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";

import { withNamespaces } from "react-i18next";

const styles = (theme) => ({
  root: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    fontFamily: "Poppins",
    cursor: "pointer",
    "&+&": {
      marginTop: "40px",
    },

    [theme.breakpoints.down("sm")]: {
      marginBottom: "40px",

      "&+&": {
        marginTop: "70px",
      },
    },
  },
  cardImageLg: {
    display: "block",
    width: "100%",
    borderTopLeftRadius: "30px",
    borderTopRightRadius: "30px",
    // borderRadius: "0px 0px 30px 30px",
    objectFit: "cover",
    [theme.breakpoints.down("sm")]: {
      height: "50rem",
      marginBottom: "12rem",
    },

    [theme.breakpoints.up("sm")]: {
      height: "45rem",
      marginBottom: "6rem",
    },

    [theme.breakpoints.up("md")]: {
      height: "unset",
      borderRadius: "30px",
      marginBottom: "0rem",
    },
  },
  cardImageSm: {
    display: "block",
    width: "100%",
    borderTopLeftRadius: "30px",
    borderTopRightRadius: "30px",
    objectFit: "cover",
    [theme.breakpoints.down("sm")]: {
      height: "30rem",
    },

    [theme.breakpoints.up("sm")]: {
      height: "25rem",
    },

    [theme.breakpoints.up("md")]: {
      height: "259px",
      borderRadius: "30px",
    },
  },
  descriptionContainer: {
    borderRadius: "30px",
    width: "100.5%",
    boxShadow: "0px 10px 60px " + theme?.colors?.containerShadow,

    backgroundColor: theme?.colors?.footer?.backgroundColor,
    padding: "24px 16px",
    position: "absolute",
    bottom: "-1px",
    left: "-1px",

    [theme.breakpoints.down("sm")]: {
      bottom: "-40px",
    },
  },
  title: {
    fontWeight: "600",
    fontSize: "1.3rem",
    color: theme?.colors?.aboutCard?.title,
    margin: "0",
  },
  description: {
    fontSize: "1.1rem",
    color: "#A0A0A0",
    margin: "8px 0 0 0",
  },
});

const aboutStarterCard = ({
  styles,
  descriptionContainerStyles,
  classes,
  image,
  title,
  description,
  onClick,
  size,
}) => {
  return (
    <div className={classes.root} onClick={onClick}>
      <img
        style={{ ...styles }}
        className={size === "lg" ? classes.cardImageLg : classes.cardImageSm}
        src={image}
        alt=""
      />
      <div
        className={classes.descriptionContainer}
        style={{ ...descriptionContainerStyles }}
      >
        <p className={classes.title}>{title}</p>
        {description && <p className={classes.description}>{description}</p>}
      </div>
    </div>
  );
};

export default withNamespaces()(
  withRouter(withStyles(styles)(aboutStarterCard))
);
